import {
  LANGUAGE_NICE_NAMES,
  type MightierSupportedLanguage,
} from "@neuromotion-inc/mightier-ts-sdk";

import { useTranslation } from "react-i18next";

export const languageOptions: {
  value: MightierSupportedLanguage;
  label: string;
}[] = Object.entries(LANGUAGE_NICE_NAMES).map((pair) => {
  return { value: pair[0] as MightierSupportedLanguage, label: pair[1] };
});

export const useCurrentLanguageTag = (): {
  language: MightierSupportedLanguage;
} => {
  const { i18n } = useTranslation();
  return {
    language: i18n.language as MightierSupportedLanguage,
  };
};
